export const LANGUAGE_LOADERS = {
	"pt-BR": () => import("../pt-BR/pt-br-translate"),
	"es-ES": () => import("../es-ES/es-es-translate"),
	"en-US": () => import("../en-US/en-us-translate"),
} as const;

export type LanguageLocale = keyof typeof LANGUAGE_LOADERS;
